import { useParams } from "react-router-dom";
import useQueryBuilding from "ApiLayer/Building/queryBuildingModel";
import { useBuildingModelUid } from "hooks/useBuildingModelUid";

export const useSelectedBuildingModelCarbonReductionPlan = () => {
    const { buildingModelUid, buildingModelCarbonReductionPlanId } = useParams();
    const altBuildingModelUid = useBuildingModelUid();
    let selectedBuildingModelUid = buildingModelUid;
    if (!selectedBuildingModelUid) {
        selectedBuildingModelUid = altBuildingModelUid;
    }
    const { data: buildingModel, isLoading, isFetching, isRefetching } = useQueryBuilding(selectedBuildingModelUid!);
    const selectedPlan = buildingModel?.carbonReductionPlans.find(
        (bmcrp) => bmcrp?.id === buildingModelCarbonReductionPlanId
    );
    const reportedPlan = buildingModel?.carbonReductionPlans.find((bmcrp) => bmcrp?.isReported);
    // console.log(
    //     `building model ids... ${buildingModelUid} / ${altBuildingModelUid} / ${selectedBuildingModelUid}, isLoading: ${isLoading} / ${isFetching} / ${isRefetching} , buildingModel: ${buildingModel}, bmcrp: ${buildingModelCarbonReductionPlanId} / ${selectedPlan} `
    // );

    return {
        bmcrp: selectedPlan as BuildingModelCarbonReductionPlan,
        reportedBMCRP: reportedPlan as BuildingModelCarbonReductionPlan,
        buildingModel,
        isLoading: isLoading || isFetching || isRefetching,
    };
};
